import { render } from "./purchase-order-status-badge.vue?vue&type=template&id=4ef5deb0"
import script from "./purchase-order-status-badge.vue?vue&type=script&lang=js"
export * from "./purchase-order-status-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__